import { Box  } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export const ContentWrapper = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
	return (
		<Box
			px={{ base: 8, md: 20 }}
			py={{ base: 8, md: 12 }}
			w="100%"
			{...props}
		>
			{children}
		</Box>
	);
};
